import React from 'react';

const withProps = (customProps) => (Component) => (props) => {
  return <Component {...{ ...props, ...customProps }} />;
};

export default withProps;
